import { render, staticRenderFns } from "./DeliveriesModal.vue?vue&type=template&id=389ef0a2&scoped=true&"
import script from "./DeliveriesModal.vue?vue&type=script&lang=js&"
export * from "./DeliveriesModal.vue?vue&type=script&lang=js&"
import style0 from "./DeliveriesModal.vue?vue&type=style&index=0&id=389ef0a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389ef0a2",
  null
  
)

export default component.exports